/* eslint-disable react/no-unescaped-entities */
import Layout from "@/components/common/Layout/Layout";
import React, { useEffect, useState } from "react";
import background from "../../assets/mic.webp";
import logo from "../../assets/logo podcast color .png";
import {
  FaAngleDown,
  FaCalendarAlt,
  FaRecycle,
  FaRegPauseCircle,
  FaRegPlayCircle,
} from "react-icons/fa";
import { FcLike } from "react-icons/fc";
import Image from "next/image";

import { useGetAllEpisodeQuery } from "@/Redux/features/episode/episodeApi";
import { useRouter } from "next/router";
import { useDispatch } from "react-redux";
import { usePlayer } from "@/context/PlayerContext";
import { setAudio } from "@/Redux/features/audioPlayer/audioPlayerSlice";
import Loading from "@/components/common/loading";
import { useSearchItemsQuery } from "@/Redux/features/podcast/podcastApi";
import VideoPlayer from "@/components/common/videoPlayer";
import { SiAirplayaudio } from "react-icons/si";
import { SiAirplayvideo } from "react-icons/si";
import playMusic from '../../assets/musicplay_icon.webp'

const Episode = () => {
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const [play, setPlay] = useState("");
  const { togglePlay, togglePause } = usePlayer();
  const [audioPlay, setAudioPlay] = useState(false)


  const router = useRouter();

  const dispatch = useDispatch();
  const handleSetAudio = (data) => {
    // console.log(data);
    dispatch(setAudio({ episode: data?.episode, audioUrl: data?.url }));
    togglePlay();
  };

  const { data: episodes, isLoading } = useGetAllEpisodeQuery(limit);

  // console.log(episodes.episode[0]?.audioURL?.path);
  const { data: searchItem, isFetching } = useSearchItemsQuery(search);

  const Episodes = search ? searchItem?.result?.episodes : episodes?.episode;

  // console.log(Episodes);
  // Helper function to format seconds to hh:mm:ss
  const formatDuration = (durationInSeconds) => {
    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor((durationInSeconds % 3600) / 60);
    const seconds = Math.floor(durationInSeconds % 60);

    return `${hours < 10 ? "0" : ""}${hours}:${minutes < 10 ? "0" : ""
      }${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };



  useEffect(() => {
    const audioPaths = Episodes?.map(episode => episode?.audioID?.path);
    setAudioPaths(audioPaths)
  }, [Episodes])

  const [currentVideoIndex, setCurrentVideoIndex] = useState(null);
  const [audioPaths, setAudioPaths] = useState("");
  const handleVideoItemClick = (index) => {
    setCurrentVideoIndex(index);
  };

  // console.log(Episodes);
  return (
    <Layout pageTitle={"Podcast | Episode"}>
      {isLoading && <Loading />}
      <section
        style={{ background: `url(${background.src})` }}
        className="relative h-auto !bg-no-repeat !bg-center !bg-cover z-10"
      >
        <div className="absolute top-0 left-0 w-full h-full bg-[#d4d4ec]  opacity-90  dark:bg-gray-900 -z-10"></div>

        <section className="max-w-screen-xl   mx-auto p-2">
          <p className="text-3xl md:text-4xl lg:text-6xl dark:text-white pt-10 font-bold">
            Podcast Audio's Episode
          </p>

          <div className="text-sm dark:text-white flex justify-between my-10 md:my-14 lg:my-20 font-semibold">
            <p className="uppercase">
              Result 1-{Episodes?.length} of{" "}
              {episodes?.pagination?.totalEpisode?.length}
            </p>
          </div>

          <section className="lg:grid grid-cols-12 gap-10 ">
            {
              play ?
                <div className={`${play && 'col-span-6'}`}>
                  <VideoPlayer videoList={audioPaths} currentVideoIndex={currentVideoIndex} setCurrentVideoIndex={setCurrentVideoIndex} />
                </div>
                :

                <div className="lg:col-span-4 ">
                  <div className="bg-gray-50 dark:bg-gray-700 dark:text-white p-10 rounded-lg">
                    <p className="text-2xl font-bold">Search</p>

                    <div className="md:flex justify-between items-center">
                      <input
                        className="p-2 rounded-md mt-5 dark:bg-gray-700 border"
                        type="text"
                        placeholder="Search"
                        value={search}
                        onChange={(e) => setSearch(e?.target?.value)}
                      />
                      {search && (
                        <p
                          onClick={() => setSearch("")}
                          className=" text-lg cursor-pointer text-blue-600 font-semibold"
                        >
                          {" "}
                          <FaRecycle className="my-auto text-4xl" />
                        </p>
                      )}
                    </div>
                  </div>
                </div>
            }

            <div className={`${play ? "lg:col-span-6" : "lg:col-span-8"}`}>
              {Episodes?.length > 0 ? (
                <>
                  {Episodes?.length > 0 &&
                    Episodes?.map((episode, i) => (
                      <div
                        key={i}
                        className={`${i === currentVideoIndex
                          ? "bg-blue-300 dark:bg-gray-700"
                          : "bg-blue-100 dark:bg-gray-900"
                          } md:flex gap-4 justify-between p-2 mb-4  dark:text-white  m-1 border border-blue-600 rounded-lg`}
                      >
                        <div className="w-full   md:flex gap-4">
                          <div className={`${play && 'hidden'}`}>
                            <Image
                              className="w-full h-72 md:w-44 md:h-44 lg:w-48  mx-auto lg:mx-0  rounded-xl"
                              src={`${episode?.picture?.path
                                ? episode?.picture?.path
                                : "/"
                                }`}
                              width={600}
                              height={400}
                              priority
                              alt="logo"
                            />
                          </div>
                          <div className="w-full my-5 md:my-auto ">
                            <p className="text-2xl font-bold mb-3">
                              {episode?.title}
                            </p>
                            <div className="lg:flex justify-between">
                              <p className="text-base font-bold">
                                Author: {episode?.createdBy?.firstName}{" "}
                                {episode?.createdBy?.lastName}
                              </p>
                              <div className={`flex gap-2 my-1 `}>
                                <p className={`${play && 'hidden'} text-base  bg-blue-100 dark:bg-gray-900 font-semibold  rounded-lg px-4`}>
                                  {formatDuration(episode?.duration.toString())}
                                </p>
                                <div className="flex gap-2 bg-gray-600 rounded-lg px-3">
                                  <FaCalendarAlt className="my-auto text-white" />
                                  <p className="my-auto text-white">
                                    {episode?.releaseDate}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="mt-1">
                          <button
                            onClick={() =>

                              router.push(
                                `/view-podcast?id=${episode?.podcastId}`
                              )

                            }
                            className="cursor-pointer  p-2 font-bold text-white bg-gradient-to-t  from-blue-400 to-[#5E1CE4] rounded-xl"
                          >
                            View Podcast
                          </button>

                          <div className="flex justify-center md:mt-8">

                            {i === currentVideoIndex ? (
                             
                              <div className="w-20 h-12">
                                <Image className="w-12 h-12 animate-pulse mx-auto rounded-full " src={playMusic} alt="playMusic" />
                              </div>

                            ) : (
                              <div className="flex gap-4 text-2xl">
                                <div

                                  onClick={() => {
                                    const data = {
                                      episode: episode,
                                      url: `${episode?.audioID?.path}`,
                                    };
                                    handleSetAudio(data);
                                    handleVideoItemClick(i);
                                    setPlay("")
                                  }}

                                  className="tooltip hover:cursor-pointer" data-tip="Play Audio">
                                  <SiAirplayaudio />
                                </div>

                                <div
                                  onClick={() => {
                                    togglePause();
                                    handleVideoItemClick(i);
                                    setPlay(episode?._id);
                                  }}
                                  className="tooltip hover:cursor-pointer" data-tip="Play Video">
                                  <SiAirplayvideo /></div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}

                  <div className="w-1/2 mx-auto my-10">
                    <button
                      onClick={() => setLimit(limit + 10)}
                      className=" uppercase text-lg font-bold text-white bg-gradient-to-r  from-blue-400 to-[#5E1CE4] p-4 px-7 rounded-[50px]"
                    >
                      Load More
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div className="border h-40 flex justify-center items-center dark:text-white">
                    <p className="text-2xl font-semibold">No data Found</p>
                  </div>
                </>
              )}
            </div>
          </section>
        </section>
      </section>

    
    </Layout>
  );
};

export default Episode;
